import { useRef, useState, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  Button,
  Container
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from 'components/Breadcrumbs';
import Iconify from 'components/Iconify';
import List from 'components/List2';
import InviteForm from 'sections/dialogs/InviteForm';
import { UserContext } from 'contexts';

import { getClients } from 'services/requests/user';
import { setMask } from 'utils';

export default function ClientsInvited() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const listRef = useRef(null);
  const userContext = useContext(UserContext);

  const [isInviting, setIsInviting] = useState(false);

  const userRole = userContext?.state?.data?.role;
  const isCompanyActive = userRole === 'admin'
    ? userContext?.state?.data?.company?.active !== false
    : userContext?.state?.data?.provider?.active !== false;

  const handleNavigate = (row, e) => {
    if (e.target.tagName === 'A') return null
    e.preventDefault()
    navigate(`/clientes/perfil/${row.id}`)
  }

  const listConfig = {
    placeholderFilter: t('clientsInvited.search'),
    onClick: (row, e) => handleNavigate(row, e),
    fields: [
      { key: 'name', label: t('clientsInvited.listFields.name'), desktopColumnSize: 4, isPrimary: true },
      { key: 'email', label: t('clientsInvited.listFields.email'), desktopColumnSize: 4 },
      {
        key: 'phone',
        label: t('clientsInvited.listFields.phone'),
        desktopColumnSize: 4,
        customValue: row => (
          <>
            <a href={`https://wa.me/+55${row.phone}`} target="_blank">{setMask('(99) 99999-9999', row.phone)}</a>
            <Iconify icon="mingcute:whatsapp-fill" width={15} sx={{ ml: 1 }} />
          </>
        )
      }
    ]
  }

  return (
    <>
      <Helmet>
        <title> {t('clientsInvited.pageTitle')} | { process.env.REACT_APP_PROJECT_NAME } </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Breadcrumbs
            items={[
              { label: t('clientsInvited.title') }
            ]}
          />
          {isCompanyActive && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => setIsInviting(true)}
              to="new"
            >
              {t('clientsInvited.new')}
            </Button>
          )}
        </Stack>

        <List
          config={listConfig}
          getData={(params) => getClients({ ...params })}
          ref={listRef}
        />
      </Container>

      <InviteForm
        open={isInviting}
        onCancel={() => setIsInviting(false)}
      />
    </>
  )
}
